export const buttonVariants = {
  primary: 'primary',
  primary_light: 'primary_light',
  secondary: 'secondary',
  red: 'red',
  primary_rounded: 'primary_rounded',
  ghost: 'ghost',
  ghost_danger: 'ghost_danger',
  outline: 'outline',
  primary_outline: 'primary_outline',
};
export const buttonSizes = {
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl',
  icon_only: 'icon_only',
};
